import React, { useContext, useEffect, useRef } from "react";
import Alert from "./Alert";
import { usePage } from "@inertiajs/react";
import { FormSpecialContext } from "@/Components/Form/Form";
import GenericContainer from "@/Components/GenericContainer.tsx";

type Props = {
    genericContainer?: boolean;
    className?: string;
    bag?: string;
};

const FlashAlert = ({
    genericContainer = false,
    className = "",
    bag = null,
}: Props) => {
    const errorRef = useRef<HTMLDivElement>(null);
    const warningRef = useRef<HTMLDivElement>(null);
    const successRef = useRef<HTMLDivElement>(null);

    const formContext = useContext(FormSpecialContext);

    const bagName = bag || formContext?.formName;

    const flash =
        (bagName ? usePage().props?.flash[bagName] : usePage().props?.flash) ??
        {};

    useEffect(() => {
        if (flash.error) {
            errorRef.current?.focus();
        }
    }, [flash.error]);

    useEffect(() => {
        if (flash.warning) {
            warningRef.current?.focus();
        }
    }, [flash.warning]);

    useEffect(() => {
        if (flash.success) {
            successRef.current?.focus();
        }
    }, [flash.success]);

    const Inside = () => (
        <>
            {flash.error && (
                <div ref={errorRef}>
                    <Alert
                        variant="error"
                        className={className}
                        title="Error"
                        // dismissable
                    >
                        {flash.error}
                    </Alert>
                </div>
            )}

            {flash.warning && (
                <div ref={warningRef}>
                    <Alert
                        variant="warning"
                        className={className}
                        title="Warning"
                        // dismissable
                    >
                        {flash.warning}
                    </Alert>
                </div>
            )}

            {flash.success && (
                <div ref={successRef}>
                    <Alert
                        variant="success"
                        className={className}
                        title="Success"
                        // dismissable
                    >
                        {flash.success}
                    </Alert>
                </div>
            )}
        </>
    );

    if (flash.error || flash.warning || flash.success) {
        if (genericContainer) {
            return (
                <GenericContainer>
                    <Inside />
                </GenericContainer>
            );
        } else {
            return (
                <React.Fragment>
                    <Inside />
                </React.Fragment>
            );
        }
    } else {
        return null;
    }
};

export default FlashAlert;
